<template lang="pug">
span(style="opacity:0.8")
  template(v-for='(d, index) in news')
    v-card(:key="index + 1" avatar="" ripple="" @click="openNews(d.id)" v-if="index < 3" style="max-width: 865px;")
      v-card-title
        div(style="display: flex;")
          div(style="flex: 1; margin-right: 10px;")
            img(class="preview-small-media-item" :src="d.thumbnailUrl") 
          div(style="flex: 6")
            div
              div {{format_date(d.created)}}
              div.font-weight-medium(style="margin-bottom:2px;") {{locale === 'kk' ? getVariableValue('titleKaz', d._embedded) : getVariableValue('title', d._embedded)}}
              div.font-weight-thin(style="margin-bottom:8px;") {{locale === 'kk' ? getVariableValue('title2Kaz', d._embedded) : getVariableValue('title2', d._embedded)}}
    v-divider.mt-1(v-if="index < 3 && index + 1 < news.length")
  template(v-if="newsTotal > 3")
    a
      v-subheader.mt-3.pb-3.font-weight-medium(ripple="" @click="openAllNews()" style="padding-left: 0px;") {{ $tf("drawer.news.all") }}...
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getLocale } from '@/i18n'

export default {
  name: 'News',

  components: {
  },

  data() {
    return {
      readyNews: []
    }
  },

  computed: {
    ...mapGetters({
      news: 'task/news',
      newsTotal: 'task/newsTotal',
    }),
    locale() {
      return getLocale()
    },
  },

  created() {
    this.getNews()
  },

  methods: {
    ...mapActions({
      getNews: 'task/getNews',
    }),
    format_date(value) { // 2022-07-18T15:40:56.994Z
      if (value) {
        return this.$moment(value).format('DD.MM.YYYY HH:mm')
      }
    },
    openNews(id) {
      this.$router.push(`/news/${id}`)
    },
    openAllNews() {
      this.$router.push('/news-list')
    },
    getVariableValue(name, content) {
      let result
      content.variable.forEach((element) => {
        if (element.name === name) {
          result = element.value
        }
      })
      return result
    },
  },
}
</script>

<style lang="stylus">
.preview-small-media-item
  width 100px
  height 100px
  display inline-block
  background url('/static/icons/loading_spinner.gif') center no-repeat
  transition transform 0.15s ease 0s
</style>



// WEBPACK FOOTER //
// src/components/home/News.vue